import React, { FC, useCallback, useEffect, useState } from 'react'
import { FieldPath, useForm } from 'react-hook-form'
import isEmail from 'validator/lib/isEmail'

import { ButtonStyles } from 'UI/Button/types'
import plusIconSrc from 'UI/Button/images/plus.svg'
import { Button } from 'UI'
import {
	AsyncThunkActionResponse,
	ResponseEntityId,
	ValidationErrorMessages
} from 'types'
import { useActions } from 'hooks/redux'
import {
	InviteStudentModal,
	SuccessInviteStudentModal
} from 'components/Courses/Tabs/Content/StudentsForm/modals'
import { InviteStudentParams } from 'API/CourseService/types'

interface InviteStudentProps {
	courseId: ResponseEntityId
}

const InviteStudent: FC<InviteStudentProps> = ({ courseId }) => {
	const [isInviteModalOpen, setIsInviteModalOpen] = useState(false)
	const [isInviteSuccessModalOpen, setIsInviteSuccessModalOpen] =
		useState(false)
	const [email, setEmail] = useState('')

	const { inviteStudent } = useActions((state) => state.course)

	const modalInviteCloseHandler = () => {
		setIsInviteModalOpen(false)
	}
	const modalInviteOpenHandler = () => {
		setIsInviteModalOpen(true)
	}

	const modalInviteSuccessCloseHandler = () => {
		setIsInviteSuccessModalOpen(false)
	}
	const modalInviteSuccessOpenHandler = () => {
		setIsInviteSuccessModalOpen(true)
	}

	const {
		register,
		formState: { errors },
		handleSubmit,
		setValue,
		control
	} = useForm<InviteStudentParams>()

	useEffect(() => {
		register('email', {
			required: ValidationErrorMessages.EMPTY,
			validate: {
				value: (value) => isEmail(value) || ValidationErrorMessages.INCORRECT
			}
		})
	}, [])

	const changeHandler = useCallback(
		(name: FieldPath<InviteStudentParams>) => (value: string) => {
			setValue(name, value)
		},
		[]
	)

	const submitHandler = useCallback(
		handleSubmit(async ({ email: responseEmail }: InviteStudentParams) => {
			const response = await inviteStudent({ email: responseEmail, courseId })
			const {
				meta: { requestStatus }
			} = response as unknown as AsyncThunkActionResponse
			if (requestStatus === 'rejected') {
				return
			}
			setEmail(responseEmail)
			modalInviteCloseHandler()
			modalInviteSuccessOpenHandler()
		}),
		[handleSubmit]
	)
	return (
		<>
			<Button
				onClick={modalInviteOpenHandler}
				styleTypes={[ButtonStyles.PRIMARY, ButtonStyles.ROUND]}
			>
				<img src={plusIconSrc} alt="plus" />
				Пригласить ученика
			</Button>
			<InviteStudentModal
				onChange={changeHandler}
				isOpen={isInviteModalOpen}
				errors={errors}
				onClose={modalInviteCloseHandler}
				onSubmit={submitHandler}
				control={control}
			/>
			<SuccessInviteStudentModal
				email={email}
				openInviteModal={modalInviteOpenHandler}
				onClose={modalInviteSuccessCloseHandler}
				isOpen={isInviteSuccessModalOpen}
			/>
		</>
	)
}

export default InviteStudent
